import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=b7f0e4b2&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f0e4b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7f0e4b2')) {
      api.createRecord('b7f0e4b2', component.options)
    } else {
      api.reload('b7f0e4b2', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=b7f0e4b2&scoped=true&", function () {
      api.rerender('b7f0e4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Se0fUePUQDoA/JS/comp/Accordion.vue"
export default component.exports